.container {
    align-items: center;
    background-color: var(--color-black);
    background-image: var(--background-image);
    background-position: var(--background-position);
    background-size: cover;
    display: flex;
    flex-direction: column;
    height: 340px;
    position: relative;
    justify-content: center;
    width: 100%;
}

.title {
    font-size: clamp(2.75rem, 7vw, 3.75rem);
    line-height: 1;
    padding-inline: 1rem;
    position: relative;
    text-align: center;
    text-shadow: 0 0 15px var(--color-black);
    text-transform: uppercase;
    z-index: 10;
}

.subtitle {
    font-size: 1.5rem;
    line-height: 1;
    margin: 1.25rem 0;
    position: relative;
    text-align: center;
    text-shadow: 0 0 15px var(--color-black);
    width: 80%;
    z-index: 10;
}

.link {
    margin-top: 2rem;
    position: relative;
    z-index: 10;
}

.textLight {
    composes: textLight from "../CustomBackgroundImageWrapper/index.module.scss";
}

.textDark {
    composes: textDark from "../CustomBackgroundImageWrapper/index.module.scss";
}
